require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-adapting-stakeholder-engagement-during-pandemic.json") })
        }
      }, "path---en-us-update-adapting-stakeholder-engagement-during-pandemic");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-adapting-stakeholder-engagement-during-pandemic!./.cache/json/en-us-update-adapting-stakeholder-engagement-during-pandemic.json
// module id = 605
// module chunks = 231608221292675